import { apiClientGeral } from '@/plugins/axios'

export default {
  getConferencias() {
    return apiClientGeral().get('/relatorios/conferencia/conferencias/lazy')
  },

  postRelatorioConferencias(form) {
    return apiClientGeral().post('/relatorios/conferencia?_method=GET', form)
  },
}
